export default __webpack_public_path__ + "static/media/ep3collage2.2269c674.jpg";